module.exports = __webpack_public_path__ + "img/p_23.db1e8612.png";